import { render, staticRenderFns } from "./Threshold.vue?vue&type=template&id=7ff0af22"
import script from "./Threshold.vue?vue&type=script&lang=js"
export * from "./Threshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports